import * as HttpService from './http';

import { http } from '../utils/constants';

const hasResponse = (res) => !res.success || res.responseCode !== 200 || !res.responseData;
const getToken = () => {
  const token = localStorage.getItem('appToken');
  if(!token) {
    return false;
  }

  return token;
}

const postLogin = async(usuario, password) => {
  const url = `${http.API_END_POINT.BASE}/auth`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const data = {
    usuario,
    password,
  }

  return HttpService.request(method, header, data, url)
    .then((response) => {
      return response;
    });
};

const getUserInfo = async(a) => {
  const url = `${http.API_END_POINT.BASE}/auth/me`;
  const method = http.METHOD_TYPE.GET;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, null, url)
    .then((response) => {
      return response;
    });
};


const getGrades = async(a) => {
  const url = `${http.API_END_POINT.BASE}/official-grades/materias-oficiales`;
  const method = http.METHOD_TYPE.GET;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, null, url)
    .then((response) => {
      return response;
    });
};

const getCaptura = async(materia) => {
  const url = `${http.API_END_POINT.BASE}/official-grades/materias-alumnos`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, materia, url)
    .then((response) => {
      return response;
    });
};

const postCalificaciones = async(calificaciones) => {
  const url = `${http.API_END_POINT.BASE}/official-grades/materias-oficiales-calificaciones`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, calificaciones, url)
    .then((response) => {
      return response;
    });
};

const getCalfCiclo = async(materia) => {
  const url = `${http.API_END_POINT.BASE}/official-grades/materias-oficiales-calificaciones-ciclo`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, materia, url)
    .then((response) => {
      return response;
    });
};

const getFaltas = async(a) => {
  const url = `${http.API_END_POINT.BASE}/faltas-oficiales/faltas`;
  const method = http.METHOD_TYPE.GET;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, null, url)
    .then((response) => {
      return response;
    });
};

const getCapturaFaltas = async(materia) => {
  const url = `${http.API_END_POINT.BASE}/faltas-oficiales/faltas-alumnos`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, materia, url)
    .then((response) => {
      return response;
    });
};

const postFaltasOficiales = async(faltas) => {
  const url = `${http.API_END_POINT.BASE}/faltas-oficiales/faltas-oficiales-faltas`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, faltas, url)
    .then((response) => {
      return response;
    });
};

const getOptionalGrades = async(a) => {
  const url = `${http.API_END_POINT.BASE}/optional-grades/materias-optativas`;
  const method = http.METHOD_TYPE.GET;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, null, url)
    .then((response) => {
      return response;
    });
};

const getCapturaOptional = async(materia) => {
  const url = `${http.API_END_POINT.BASE}/optional-grades/alumnos-optativas`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, materia, url)
    .then((response) => {
      return response;
    });
};

const postCalificacionesOptativas = async(calificaciones) => {
  const url = `${http.API_END_POINT.BASE}/optional-grades/materias-optativas-calificaciones`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, calificaciones, url)
    .then((response) => {
      return response;
    });
};

const postCalificacionesOptativasCiclo = async(calificaciones) => {
  const url = `${http.API_END_POINT.BASE}/optional-grades/materias-optativas-ciclo`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, calificaciones, url)
    .then((response) => {
      return response;
    });
};

const getCapturaFaltasOptional = async(materia) => {
  const url = `${http.API_END_POINT.BASE}/faltas-optativas/alumnos-faltas-optativas`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, materia, url)
    .then((response) => {
      return response;
    });
};

const postFaltasOptativas = async(faltas) => {
  const url = `${http.API_END_POINT.BASE}/faltas-optativas/materia-faltas-optativas`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, faltas, url)
    .then((response) => {
      return response;
    });
};

const getColegiatura = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/colegiaturas`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const postLoginInfoAlumno = async(user) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/login`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, user, url)
    .then((response) => {
      return response;
    });
};

const getInfoAlumno = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/info`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const getInfoAlumnoNombre = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/info-nombre`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const getCalificacionesAlumno = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/calificaciones`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const postBoletaInfoAlumnos = async(matricula, nivel) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos${nivel}/boleta`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const postSendEmail = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/send-email/adeudo`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const postSendEmailMasivo = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/send-email/masivo/adeudo`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const postSendEmailMasivoGeneral = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/send-email/masivo/general`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const postColegiaturasGeneral = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/colegiaturas-general`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const postColegiaturasGeneralMatricula = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/colegiaturas-general-matricula`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const postFiltrarAlumnos = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/info-alumnos/filtrar-alumnos`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const getAsistencias = async(filtros) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, filtros, url)
    .then((response) => {
      return response;
    });
};

const getInfoAlumnoCompleta = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/info-alumno`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const getFotoAlumno = async(filtros) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/foto-alumno`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, filtros, url)
    .then((response) => {
      return response;
    });
};

const getAlumnosList = async(filtros) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/alumnos-list`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, filtros, url)
    .then((response) => {
      return response;
    });
};

const getAlumnosAsistencias = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/alumnos`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, data, url)
    .then((response) => {
      return response;
    });
};

const getInfoAsistencia = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/info-asistencia`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, data, url)
    .then((response) => {
      return response;
    });
};

const postRegistrarEntrada = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/registrar-entrada`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, data, url)
    .then((response) => {
      return response;
    });
};

const postRegistrarSalida = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/registrar-salida`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, data, url)
    .then((response) => {
      return response;
    });
};

const postMessageAsistencia = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/message-asistencia`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const postMessagePrefectos = async(matricula) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/message-prefectos`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, matricula, url)
    .then((response) => {
      return response;
    });
};

const getTipoReporte = async(a) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/tipo-reporte`;
  const method = http.METHOD_TYPE.GET;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, null, url)
    .then((response) => {
      return response;
    });
};

const getPersonalReporte = async(a) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/personal-reporte`;
  const method = http.METHOD_TYPE.GET;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, null, url)
    .then((response) => {
      return response;
    });
};

const postRegistrarReporte = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/registrar-reporte`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, data, url)
    .then((response) => {
      return response;
    });
};

const getFotoPrefecto = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/foto-prefecto`;
  const method = http.METHOD_TYPE.GET;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, null, url)
    .then((response) => {
      return response;
    });
};

const getTipoJustificante = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/tipo-justificante`;
  const method = http.METHOD_TYPE.GET;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, null, url)
    .then((response) => {
      return response;
    });
};

const getJustificacion = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/justificacion`;
  const method = http.METHOD_TYPE.GET;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, null, url)
    .then((response) => {
      return response;
    });
};

const postRegistrarJustificante = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/registrar-justificante`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, data, url)
    .then((response) => {
      return response;
    });
};

const postActualizarAsistencia = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/actualizar-asistencias`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, data, url)
    .then((response) => {
      return response;
    });
};

const getAlumnosFaltantes = async(filtros) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/alumnos-faltantes`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, filtros, url)
    .then((response) => {
      return response;
    });
};

const getRetardosAlumnos = async(filtros) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/retardos-alumnos`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, filtros, url)
    .then((response) => {
      return response;
    });
};

const postMessageFaltas = async(data) => {
  const url = `${http.API_END_POINT.BASE}/asistencias/message-faltas`;
  const method = http.METHOD_TYPE.POST;

  const header = {
    'Content-Type': http.CONTENT_TYPE.APPLICATION_JSON,
  };

  const token = getToken();
  if(token) {
    header['Authorization']=token;
  }

  return HttpService.request(method, header, data, url)
    .then((response) => {
      return response;
    });
};

export default {
  postLogin,
  getUserInfo,
  getGrades,
  getCaptura,
  postCalificaciones,
  getCalfCiclo,
  getOptionalGrades,
  getCapturaOptional,
  postCalificacionesOptativas,
  postCalificacionesOptativasCiclo,
  getFaltas,
  getCapturaFaltas,
  postFaltasOficiales,
  getCapturaFaltasOptional,
  postFaltasOptativas,
  postLoginInfoAlumno,
  getColegiatura,
  getInfoAlumno,
  getCalificacionesAlumno,
  getInfoAlumnoNombre,
  postBoletaInfoAlumnos,
  postSendEmail,
  postColegiaturasGeneral,
  postColegiaturasGeneralMatricula,
  postSendEmailMasivo,
  postFiltrarAlumnos,
  postSendEmailMasivoGeneral,
  getAsistencias,
  getAlumnosAsistencias,
  getInfoAsistencia,
  postMessageAsistencia,
  postRegistrarEntrada,
  postRegistrarSalida,
  getAlumnosList,
  getFotoAlumno,
  getTipoReporte,
  postMessagePrefectos,
  getInfoAlumnoCompleta,
  postRegistrarReporte,
  getFotoPrefecto,
  getPersonalReporte,
  getTipoJustificante,
  getJustificacion,
  postRegistrarJustificante,
  postActualizarAsistencia,
  getAlumnosFaltantes,
  postMessageFaltas,
  getRetardosAlumnos
};